<!-- <div class="dialog-title">
  <h3> {{ Title}}</h3>
  <span mat-button mat-dialog-close>
    <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
      <path id="close-btn"
        d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
        transform="translate(5.82 13.32)" fill="#bbb" />
    </svg>
  </span>
</div>
<mat-dialog-content>
  <ng-container *ngIf="!loadingData">
    <div class="register-user create_auction">
      <div class="profile">
        <div class="profile-image">
          <img [src]="MainImage?.path" class="user-image" onerror="this.src='assets/images/ProfileAvatar.png'" alt=""
            srcset="">

          <div (click)="onChangeImage()" class="change-image">
            <img src="assets/images/icons/change-image-profile.svg" alt="" srcset="">
          </div>
        </div>
      </div>
      <form (ngSubmit)="onSubmit()" [formGroup]="AuctionCreateForm">
        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Title [English]'|translate}}</mat-label>
            <input formControlName="name_en" matInput maxlength="100">
            <mat-error *ngIf="hasError(AuctionCreateForm,'name_en','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Title [Arabic]'|translate}}</mat-label>
            <input formControlName="name_ar" matInput maxlength="100">
            <mat-error *ngIf="hasError(AuctionCreateForm,'name_ar','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Description [English]'|translate}}</mat-label>
            <textarea formControlName="description_en" matInput maxlength="255"></textarea>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Description [Arabic]'|translate}}</mat-label>
            <textarea formControlName="description_ar" matInput maxlength="255"></textarea>
          </mat-form-field>
        </div>

        <hr>

        <div class="title-form">
          <span>{{'Auctions.BIDs'|translate}}</span>
        </div>

        <div formArrayName="btns">
          <div *ngFor="let item of formBtnsControls.controls; let i=index" [formGroupName]="i">
            <div class="inputs-form-section">
              <mat-form-field appearance="outline" class="mb-0">
                <mat-label>{{'Auctions.Price'|translate}}</mat-label>
                <input appOnlynumber formControlName="price" matInput maxlength="20">
                <a *ngIf="i!=0" (click)="removeBtn(i)" matSuffix mat-icon-button aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </a>

              </mat-form-field>
            </div>
          </div>
          <a mat-button class="btn-secondry mb-3 w-50" (click)="addBtn()"> {{'Auctions.Add BID'|translate}}</a>
        </div>
        <hr>


        <div class="title-form">
          <span>{{"Auctions.Details"|translate}}</span>
        </div>
        <div formArrayName="details" class="container-fluid">
          <div *ngFor="let item of formDetailsControls.controls; let i=index" [formGroupName]="i" class="row">
            <p *ngIf="i%2==0" class="mb-2 text-left"><strong>{{"Auctions.Item"|translate}} {{(i/2)+1}}</strong></p>
            <div class="inputs-form-section  col-md-6 col-12">
              <mat-form-field appearance="outline" class="mb-0 ">
                <mat-label>{{formDetailsControls.controls[i].value.lang == "en"?
                  ("Auctions.Key English"|translate):
                  ("Auctions.Key Arabic"|translate)}}</mat-label>
                <input formControlName="key" matInput maxlength="50">
              </mat-form-field>
            </div>
            <div class="inputs-form-section  col-md-6 col-12">
              <mat-form-field appearance="outline" class="mb-0">
                <mat-label>
                  {{formDetailsControls.controls[i].value.lang == "en"?
                  ("Auctions.Value English"|translate):
                  ("Auctions.Value Arabic"|translate)}}
                </mat-label>
                <input formControlName="value" matInput maxlength="50">
                <a *ngIf="i>1" (click)="removeDeatilsItem(i)" matSuffix mat-icon-button aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </a>
              </mat-form-field>
            </div>
            <hr *ngIf="i%2==1">
          </div>
          <a mat-button class="btn-secondry mb-3 w-50" (click)="addDeatilsItem()"> {{"Auctions.Add Item"|translate}}</a>
        </div>
        <hr>


        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Minimum Price'|translate}}</mat-label>
            <input appOnlynumber formControlName="minimum_price" matInput maxlength="20">
            <mat-error *ngIf="hasError(AuctionCreateForm,'minimum_price','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-sm-12 slide-toggle-input mb-4">
          <mat-slide-toggle [labelPosition]="'before'" formControlName="is_published">
            {{'Auctions.Is Published'|translate}}
          </mat-slide-toggle>
        </div>

        <div class="inputs-form-section" [hidden]="!AuctionCreateForm.value.is_timer">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Total Minutes'|translate}}</mat-label>
            <input appOnlynumber formControlName="total_minutes" [required]="AuctionCreateForm.value.is_timer" matInput>
            <mat-error *ngIf="hasError(AuctionCreateForm,'total_minutes','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline">
            <mat-label>{{"Auctions.Date"|translate}}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date" [min]="Date_Min_Max.min"
              [max]="Date_Min_Max.max">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="hasError(AuctionCreateForm,'date','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
            <mat-error
              *ngIf="hasError(AuctionCreateForm,'date','matDatepickerMin')||hasError(AuctionCreateForm,'date','matDatepickerMax')">
              {{"Auctions.Date Out of Range"|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline">
            <mat-label>{{"Auctions.Start Time"|translate}} </mat-label>
            <input matInput [format]="12" formControlName="start_at" [max]="AuctionCreateForm.value.end_at"
              [ngxMatTimepicker]="pickerStart" placeholder="12:00" readonly />
            <ngx-mat-timepicker-toggle matSuffix (click)="pickerStart.open()"></ngx-mat-timepicker-toggle>
            <mat-error *ngIf="hasError(AuctionCreateForm,'start_at','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
          <ngx-mat-timepicker color="primary" #pickerStart></ngx-mat-timepicker>
        </div>
        <div class="inputs-form-section">
          <mat-form-field appearance="outline">
            <mat-label>{{"Auctions.End Time"|translate}} </mat-label>
            <input matInput [format]="12" formControlName="end_at" [min]="AuctionCreateForm.value.start_at"
              [ngxMatTimepicker]="pickerEnd" placeholder="12:00" readonly />
            <ngx-mat-timepicker-toggle matSuffix (click)="pickerEnd.open()">
              <mat-icon>access_time</mat-icon>
            </ngx-mat-timepicker-toggle>
            <mat-error *ngIf="hasError(AuctionCreateForm,'end_at','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
          <ngx-mat-timepicker color="primary" #pickerEnd></ngx-mat-timepicker>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{"Auctions.Link Streaming"|translate}}</mat-label>
            <input formControlName="link_streaming" matInput>
            <mat-error *ngIf="hasError(AuctionCreateForm,'link_streaming','pattern')">
              {{"Auctions.Invalid link streaming"|translate}}
            </mat-error>
            <mat-error *ngIf="hasError(AuctionCreateForm,'link_streaming','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <p class="mb-3"> <strong>{{"Auctions.Media"|translate}} :</strong> </p>

          <app-file-manager [files]="files" [isUploader]="true" [isSubmited]="isSubmitted"
            (selectedFiles)="files=$event;" [allowedExt]="['png','jpg','jpeg']" [MaxFileSize]="5"
            managerIndex="MediaImages"></app-file-manager>
        </div>

        <button mat-button [disabled]="loading" class="btn btn-primary w-100 mt-3" type="submit">
          {{'Auctions.Submit'|translate}}
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
      </form>
    </div>
  </ng-container>



  <div *ngIf="loadingData" class="dataLoading">
    <mat-spinner [color]="'darkmagenta'" class="m-auto" diameter="50"></mat-spinner>
  </div>
</mat-dialog-content> -->


<div class="dialog-title">
  <h3> {{ Title}}</h3>
  <span mat-button mat-dialog-close>
    <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
      <path id="close-btn"
        d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
        transform="translate(5.82 13.32)" fill="#bbb" />
    </svg>
  </span>
</div>
<mat-dialog-content class="p-0 create_auction" *ngIf="!loadingData && !loadingCategory">
  <!-- <button mat-button (click)="onSuccessAdd()">text</button> -->
  <mat-stepper [linear]="true" (window:resize)="onWindowResize($event)"  [orientation]="getScreenWidth < 870?'vertical':'horizontal'"  #stepper>

    <!-- orientation="vertical"  -->

    <mat-step [stepControl]="MainInfo_Form">

      <form [formGroup]="MainInfo_Form" (ngSubmit)="formSubmited=true">
        <ng-template matStepLabel>{{'items-requests.Main Info' | translate}}</ng-template>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Title [English]'|translate}}</mat-label>
            <input formControlName="name_en" matInput maxlength="100">
            <mat-error *ngIf="hasError(MainInfo_Form,'name_en','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
            <mat-error *ngIf="hasError(MainInfo_Form,'name_en','pattern')">
              {{'items-requests.accept only English and special characters' | translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Title [Arabic]'|translate}}</mat-label>
            <input formControlName="name_ar" matInput maxlength="100">
            <mat-error *ngIf="hasError(MainInfo_Form,'name_ar','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Description [English]'|translate}}</mat-label>
            <textarea formControlName="description_en" matInput maxlength="255" rows="6"></textarea>
            <mat-error *ngIf="hasError(MainInfo_Form,'description_en','pattern')">
              {{'items-requests.accept only English and special characters' | translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Auctions.Description [Arabic]'|translate}}</mat-label>
            <textarea formControlName="description_ar" matInput maxlength="255" rows="6"></textarea>
          </mat-form-field>
        </div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline">
            <mat-label>{{'Auctions.Category'|translate}}</mat-label>
            <mat-select formControlName="category_id">
              <mat-option *ngFor="let item of categoriesList" [value]="item.id" (click)="LoadCategoryTemplate(item.id)">
                {{item.name}}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="hasError(MainInfo_Form,'category_id','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngIf="data?.approve_request">

          <div class="title">{{'items-requests.Select the auction to include this item in' | translate}}</div>

          <mat-form-field appearance="outline">
            <mat-label>{{'Home.Auction' | translate}}</mat-label>
            <input type="text" placeholder="{{'items-requests.Search by name' | translate}} ..." aria-label="Creator"
              matInput [(ngModel)]="RoomModal.search" [ngModelOptions]="{standalone:true}" [matAutocomplete]="auto"
              (keyup.enter)="onGetSearchRoomsList(true)">
            <mat-icon matSuffix (click)="onGetSearchRoomsList(true)">search</mat-icon>

            <mat-autocomplete #auto="matAutocomplete">
              <div style="height: 100%;overflow-y: scroll;" (scrolled)="onGetSearchRoomsList(false)"
                [infiniteScrollDistance]="2" [infiniteScrollThrottle]="RoomsPagesCount" [scrollWindow]="false"
                infiniteScroll><mat-option *ngFor="let option of RoomsList" [value]="option.name"
                  (click)="OnSelectRoom(option)">
                  {{option.name|titlecase}}
                </mat-option>
                <mat-option disabled *ngIf="!RoomsList.length && !loadingRooms">{{'items-requests.Not found data' |
                  translate}}</mat-option>
                <mat-option *ngIf="!RoomsList.length && loadingRooms"><span
                    [appLoading]="true">Loading</span></mat-option>
              </div>
            </mat-autocomplete>
            <mat-hint class="mat-error text-start" *ngIf="hasError(MainInfo_Form,'room_id','required') && formSubmited">
              {{'Auctions.Field is Required'|translate}}</mat-hint>
          </mat-form-field>



        </ng-container>
        <div [hidden]="data.in_multi_room">
          <div class="title">{{'items-requests.Bidding Time' | translate}}</div>

          <div class="inputs-form-section">
            <mat-form-field appearance="outline" [class.disabled]="!MainInfo_Form.value.room_id">
              <mat-label>{{"Auctions.Date"|translate}}</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date"
                [min]="!data.in_multi_room?Date_Min_Max.min:null" [max]="!data.in_multi_room?Date_Min_Max.max:null"
                [required]="!data.in_multi_room">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error *ngIf="hasError(MainInfo_Form,'date','required')">
                {{'Auctions.Field is Required'|translate}}
              </mat-error>
              <mat-error
                *ngIf="hasError(MainInfo_Form,'date','matDatepickerMin')||hasError(MainInfo_Form,'date','matDatepickerMax')">
                {{"Auctions.Date Out of Range"|translate}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="SlideToggle">
            <mat-slide-toggle color="primary" [disabled]="Configration_Form.value?.is_reserve" id="slideToggle"
              [(ngModel)]="AuctionItemHaveEndTime" [ngModelOptions]="{standalone:true}" [labelPosition]="'before'">
              <mat-label for="slideToggle"> {{'items-requests.Item have end time' | translate}} </mat-label>
            </mat-slide-toggle>
            <div class="desc">
              <p>{{'items-requests.If you choose, an end date will be set for that item.' | translate}}
              </p>
            </div>
            <div class="row mt-3">
              <div class="inputs-form-section"
                [ngClass]="{'col-md-6 col-12': AuctionItemHaveEndTime , 'col-12':!AuctionItemHaveEndTime}">
                <mat-form-field appearance="outline">
                  <mat-label>{{"Auctions.Start Time"|translate}} </mat-label>
                  <input matInput [format]="12" formControlName="start_at" [max]="!data.in_multi_room?TimeStartMax:null"
                    [ngxMatTimepicker]="pickerStart" placeholder="12:00" readonly [required]="!data.in_multi_room" />
                  <ngx-mat-timepicker-toggle matSuffix (click)="pickerStart.open()"></ngx-mat-timepicker-toggle>
                  <mat-error *ngIf="hasError(MainInfo_Form,'start_at','required')">
                    {{'Auctions.Field is Required'|translate}}
                  </mat-error>
                </mat-form-field>
                <ngx-mat-timepicker color="primary" #pickerStart></ngx-mat-timepicker>
              </div>
              <div class="inputs-form-section col-md-6 col-12" [hidden]="!AuctionItemHaveEndTime">
                <mat-form-field appearance="outline">
                  <mat-label>{{"Auctions.End Time"|translate}} </mat-label>
                  <input matInput [format]="12" formControlName="end_at" [min]="!data.in_multi_room?TimeEndMin:null"
                    [ngxMatTimepicker]="pickerEnd" placeholder="12:00" readonly
                    [required]="AuctionItemHaveEndTime && !data.in_multi_room" />
                  <ngx-mat-timepicker-toggle matSuffix (click)="pickerEnd.open()">
                    <mat-icon>access_time</mat-icon>
                  </ngx-mat-timepicker-toggle>
                  <mat-error *ngIf="hasError(MainInfo_Form,'end_at','required')">
                    {{'Auctions.Field is Required'|translate}}
                  </mat-error>
                </mat-form-field>
                <ngx-mat-timepicker color="primary" #pickerEnd></ngx-mat-timepicker>
              </div>
            </div>

          </div>
        </div>

        <div class="group_btn justify-content-between">
          <button mat-button class="btnLight_fill" mat-dialog-close>{{'actions.cancel' | translate}}</button>
          <!-- <div> </div> -->
          <button mat-button class="btn_fill" type="submit" matStepperNext>{{'items-requests.Next' |
            translate}}</button>

        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="Details_Photos_Form">
      <form [formGroup]="Details_Photos_Form">
        <ng-template matStepLabel>{{'items-requests.Item Details & Photos' | translate}}</ng-template>
        <div class="title">{{'Auction Item.Item Details' |translate}}</div>
        <div class="table-responsive">
          <table class="w-100 table-responsive">
            <thead>
              <tr>
                <th width="5%"></th>
                <th width="45%">{{'items-requests.Lable' |translate}}</th>
                <th width="45%">{{'items-requests.Value' |translate}}</th>
                <th width="5%"></th>
              </tr>
            </thead>
            <tbody formArrayName="details" cdkDropList (cdkDropListDropped)="drop($event)">
              <tr *ngFor="let item of formDetailsControls.controls; let i=index" [formGroupName]="i" [id]="i"
                [cdkDragDisabled]="itemSelected==i" (cdkDragDropped)="dropping=false" cdkDrag class="details_item">
                <td width="5%" class="DragIcon">
                  <img width="20" height="20" cdkDragHandle src="assets/images/icons/DragDropIcon.svg" alt="">
                </td>
                <td width="45%">
                  <div class="inputs-form-section w-100">
                    <mat-form-field appearance="outline" class="pb-1">
                      <mat-label>{{
                        ("Auctions.Key English"|translate)}}
                      </mat-label>
                      <input formControlName="key_en" matInput maxlength="50">
                      <mat-error *ngIf="getValidity(i,'key_en','required')">
                        {{'Auctions.Field is Required'|translate}}
                      </mat-error>
                      <mat-error *ngIf="getValidity(i,'key_en','pattern')">
                        {{'items-requests.accept only English and special characters' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="inputs-form-section w-100">
                    <mat-form-field appearance="outline" class="pb-1">
                      <mat-label>{{
                        ("Auctions.Key Arabic"|translate)}}
                      </mat-label>
                      <input formControlName="key_ar" matInput maxlength="50">
                      <mat-error *ngIf="getValidity(i,'key_ar','required')">
                        {{'Auctions.Field is Required'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>

                </td>
                <td width="45%">
                  <div class="inputs-form-section  w-100">
                    <mat-form-field appearance="outline" class="pb-1">
                      <mat-label>
                        {{
                        ("Auctions.Value English"|translate)}}
                      </mat-label>
                      <input formControlName="value_en" matInput maxlength="50">
                      <mat-error *ngIf="getValidity(i,'value_en','required')">
                        {{'Auctions.Field is Required'|translate}}
                      </mat-error>
                      <mat-error *ngIf="getValidity(i,'value_en','pattern')">
                        {{'items-requests.accept only English and special characters' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="inputs-form-section  w-100">
                    <mat-form-field appearance="outline" class="pb-1">
                      <mat-label>
                        {{
                        ("Auctions.Value Arabic"|translate)}}
                      </mat-label>
                      <input formControlName="value_ar" matInput maxlength="50">
                      <mat-error *ngIf="getValidity(i,'value_ar','required')">
                        {{'Auctions.Field is Required'|translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>

                </td>
                <td width="5%" class="colseIcon">
                  <div (click)="removeDeatilsItem(i)" class="rounded-circle" aria-label="Clear" *ngIf="i">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10.604" height="10.604" viewBox="0 0 10.604 10.604">
                      <path id="close-ic"
                        d="M207.3,304.561l-3.776,3.776a.89.89,0,1,1-1.259-1.259l3.776-3.776-3.776-3.776a.89.89,0,1,1,1.259-1.259l3.776,3.776,3.776-3.776a.89.89,0,1,1,1.259,1.259l-3.776,3.776,3.776,3.776a.89.89,0,1,1-1.259,1.259Z"
                        transform="translate(-202 -298)" fill="#8479ac" />
                    </svg>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div class="group_btn pt-1 justify-content-start">
          <button type="button" mat-button class="btnLight_fill" (click)="addDeatilsItem()">

            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
              <path id="plus"
                d="M15.25,9.25h-4.5V4.75a.75.75,0,1,0-1.5,0v4.5H4.75a.75.75,0,1,0,0,1.5h4.5v4.5a.75.75,0,0,0,1.5,0v-4.5h4.5a.75.75,0,0,0,0-1.5Z"
                transform="translate(-4 -4)" fill="#70639e" />
            </svg>

            {{'items-requests.Add Item Details' | translate}}</button>
        </div>


        <div class="inputs-form-section mt-5">

          <app-file-manager [label]="'Auctions.Item Banner'|translate" [isUploader]="true" [isSubmited]="isSubmitted"
            (selectedFiles)="MainImage=$event;" (UploadLoading)="LoadingUploadBanner=$event"
            [allowedExt]="['png','jpg','jpeg']" [MaxFileSize]="5" managerIndex="ItemBanner" [Mode]="'banner'"
            [maxFiles]="1" [InitialImage]="MainImage?MainImage[0]?.path:''"></app-file-manager>
        </div>



        <div class="inputs-form-section  mt-5">
          <app-file-manager [label]="'Auctions.Media'|translate" [files]="files" [isUploader]="true"
            [isSubmited]="isSubmitted" (selectedFiles)="files=$event;" (UploadLoading)="LoadingUploadMedia=$event"
            [allowedExt]="['png','jpg','jpeg','mp4']" [MaxFileSize]="200" managerIndex="MediaImages"
            [Mode]="'multi'"></app-file-manager>
        </div>


        <div class="group_btn justify-content-between">
          <button mat-button class="btnLight_fill" matStepperPrevious>{{'items-requests.Back' | translate}}</button>
          <button mat-button class="btn_fill" type="submit" matStepperNext
            [disabled]="LoadingUploadBanner||LoadingUploadMedia || !MainImage?.length">{{'items-requests.Next' |
            translate}}</button>

        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="Configration_Form">

      <form [formGroup]="Configration_Form">
        <ng-template matStepLabel>{{'items-requests.Bidding Configuration' | translate}}</ng-template>

        <div class="title">{{'Main Auction.Starting bid' | translate}}</div>
        <div class="subtitle">{{'items-requests.Set a fair and reasonable' | translate}}</div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'Main Auction.Starting bid' | translate}}</mat-label>
            <input appOnlynumber formControlName="minimum_price" matInput maxlength="9">
            <span matTextSuffix>{{"Auction Item.SR"|translate}}</span>
            <mat-error *ngIf="hasError(Configration_Form,'minimum_price','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
            <mat-error *ngIf="hasError(Configration_Form,'minimum_price','min')">
              {{'items-requests.Minumum number is 1' | translate}}
            </mat-error>
          </mat-form-field>
        </div>

        <ng-container>

          <div class="SlideToggle mt-5" [hidden]="!AuctionItemHaveEndTime || data.in_multi_room">
            <mat-slide-toggle color="primary" id="slideToggle" formControlName="is_reserve" [labelPosition]="'before'">
              <mat-label for="slideToggle"> {{'items-requests.Set reserve price' | translate}} </mat-label>
            </mat-slide-toggle>
            <div class="desc">
              <p>{{"items-requests.This is the lowest price you're willing to sell the item for" | translate}}
              </p>
              <p>{{"items-requests.In-this-case-even" | translate}}
              </p>
              <p>{{"items-requests.The reserve price" | translate}}</p>
            </div>
          </div>


          <div class="inputs-form-section" [hidden]="!Configration_Form.value.is_reserve">
            <mat-form-field appearance="outline" class="form-group">
              <mat-label>{{'Auction Item.Reserveprice' | translate}}</mat-label>
              <input appOnlynumber 
                formControlName="reserve_price" [required]="Configration_Form.value.is_reserve" matInput maxlength="9">
              <span matTextSuffix>{{"Auction Item.SR"|translate}}</span>
              <mat-error *ngIf="hasError(Configration_Form,'reserve_price','required')">
                {{'Auctions.Field is Required'|translate}}
              </mat-error>
              <mat-error *ngIf="hasError(Configration_Form,'reserve_price','min')">
                {{'items-requests.Minumum number is 1'|translate}}
              </mat-error>
            </mat-form-field>
          </div>

        </ng-container>

        <h3>{{'items-requests.Configuration shown for the Bidders while bidding'|translate}}</h3>

        <div class="title">{{'items-requests.Manually bidding'|translate}}</div>
        <div class="subtitle">{{'items-requests.Manually bidding increases by this amount'|translate}}.</div>

        <div class="inputs-form-section">
          <mat-form-field appearance="outline" class="form-group">
            <mat-label>{{'items-requests.Bid increment'|translate}}</mat-label>
            <input appOnlynumber  formControlName="manual_bidding" matInput maxlength="9">
            <span matTextSuffix>{{"Auction Item.SR"|translate}}</span>
            <mat-error *ngIf="hasError(Configration_Form,'manual_bidding','required')">
              {{'Auctions.Field is Required'|translate}}
            </mat-error>
            <mat-error *ngIf="hasError(Configration_Form,'manual_bidding','min')">
              {{'items-requests.Minumum number is 1'|translate}}
            </mat-error>

          </mat-form-field>
        </div>

        <div class="preview">
          <div class="text">{{'items-requests.Preview'|translate}}</div>
          <div class="counter">
            <div class="minus rounded-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="10.417" height="1.563" viewBox="0 0 10.417 1.563">
                <path id="minus_ic" d="M200.781,533.563a.781.781,0,0,1,0-1.562h8.854a.781.781,0,0,1,0,1.563Z"
                  transform="translate(-200 -532)" fill="#ada6c8" />
              </svg>
            </div>
            <div class="value"><span>{{"Auction Item.SR"|translate}}</span> {{Configration_Form.value.manual_bidding}}
            </div>
            <div class="minus rounded-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="10.416" height="10.416" viewBox="0 0 10.416 10.416">
                <path id="add_ic"
                  d="M205.2,306.416a.534.534,0,0,1-.4-.16.544.544,0,0,1-.158-.4v-4.092h-4.092a.538.538,0,0,1-.4-.161.545.545,0,0,1-.16-.4.534.534,0,0,1,.16-.4.544.544,0,0,1,.4-.158h4.092v-4.092a.539.539,0,0,1,.161-.4.545.545,0,0,1,.4-.16.534.534,0,0,1,.4.16.544.544,0,0,1,.158.4v4.092h4.092a.539.539,0,0,1,.4.161.545.545,0,0,1,.16.4.534.534,0,0,1-.16.4.544.544,0,0,1-.4.158h-4.092v4.092a.539.539,0,0,1-.161.4A.545.545,0,0,1,205.2,306.416Z"
                  transform="translate(-200 -296)" fill="#322075" />
              </svg>

            </div>
          </div>
        </div>




        <div class="title">{{'items-requests.Quick bidding buttons'|translate}}</div>
        <div class="subtitle">{{'items-requests.The bidders are shown these buttons as a shortcut for quick
          bidding'|translate}}.</div>

        <div class="SlideToggle mb-2">
          <mat-slide-toggle color="primary" id="slideToggle1" [(ngModel)]="UseDefualtValues"
            [ngModelOptions]="{standalone: true}" [labelPosition]="'before'">
            <mat-label for="slideToggle"> {{'items-requests.Use default values'|translate}}?</mat-label>
          </mat-slide-toggle>
        </div>


        <div [class.disabled]="UseDefualtValues">
          <div formArrayName="btns" class="row">
            <div *ngFor="let item of formBtnsControls.controls; let i=index" [formGroupName]="i"
              class="col-md-4 col-12">
              <div class="inputs-form-section">
                <mat-form-field appearance="outline" class="mb-0">
                  <mat-label>{{"Auctions.button"|translate}}
                    <span *ngIf="i==0">{{"Auctions.st"|translate}}</span>
                    <span *ngIf="i==1">{{"Auctions.nd"|translate}}</span>
                    <span *ngIf="i==2">{{"Auctions.rd"|translate}}</span>
                  </mat-label>
                  <input appOnlynumber [min]="49" formControlName="price" matInput [maxlength]="9"
                    [readonly]="UseDefualtValues">
                  <span matTextSuffix>{{"Auction Item.SR"|translate}}</span>
                  <mat-error *ngIf="btns_hasError(i,'price','required')">
                    {{'Auctions.Field is Required'|translate}}
                  </mat-error>
                  <mat-error *ngIf="btns_hasError(i,'price','min')">
                    {{'items-requests.Minumum number is 1'|translate}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>


        <!-- <div class="title">{{'items-requests.Streaming Link' | translate}}</div>

        <mat-form-field appearance="outline" class="form-group">
          <mat-label>{{"Auctions.Link Streaming"|translate}}</mat-label>
          <input formControlName="link_streaming" matInput type="url" maxlength="255">
          <mat-error *ngIf="hasError(Configration_Form,'link_streaming','pattern')">
            {{"Auctions.Invalid link streaming"|translate}}
          </mat-error>
          <mat-error *ngIf="hasError(Configration_Form,'link_streaming','required')">
            {{'Auctions.Field is Required'|translate}}
          </mat-error>
        </mat-form-field> -->


        <div class="group_btn justify-content-between">
          <button mat-button class="btnLight_fill" matStepperPrevious>{{'items-requests.Back' | translate}}</button>
          <button mat-button class="btn_fill" type="submit" [appLoading]="loading"
            (click)="onSubmit(AuctionItemHaveEndTime)">{{btnSubmit}}</button>
        </div>

      </form>
    </mat-step>

  </mat-stepper>



</mat-dialog-content>

<app-loading *ngIf="loadingData || loadingCategory"></app-loading>